import {create} from "zustand";

export const useData = create((set, get) => ({
  isAuth:
    localStorage.getItem("user") && localStorage.getItem("user") !== "undefined"
      ? JSON.parse(localStorage.getItem("user"))
      : false,
  setIsAuth: (data) => set({isAuth: data}),

  triggerCount: 0,
  setTriggers: () => set({triggerCount: get().triggerCount + 1}),

  loading: false,
  setLoading: (data) =>
    set({
      loading: data,
    }),

  serviceOrderTickets: false,
  setServiceOrderTickets: (data) =>
    set({
      serviceOrderTickets: data,
    }),

  problemTypes: false,
  setProblemTypes: (data) =>
    set({
      problemTypes: data,
    }),

  serviceTypes: false,
  setServiceTypes: (data) =>
    set({
      serviceTypes: data,
    }),

  customers: false,
  setCustomers: (data) =>
    set({
      customers: data,
    }),

  serviceBases: false,
  setServiceBases: (data) =>
    set({
      serviceBases: data,
    }),

  workStatuses: false,
  setWorkStatuses: (data) =>
    set({
      workStatuses: data,
    }),

  serviceEngineers: false,
  setServiceEngineers: (data) =>
    set({
      serviceEngineers: data,
    }),

  responseStatuses: false,
  setResponseStatuses: (data) =>
    set({
      responseStatuses: data,
    }),

  priorities: false,
  setPriorities: (data) =>
    set({
      priorities: data,
    }),

  partPlatforms: false,
  setPartPlatforms: (data) =>
    set({
      partPlatforms: data,
    }),

  sidebarState: false,
  setSidebarState: (data) =>
    set({
      sidebarState: data,
    }),

  currentExport: "",
  setCurrentExport: (data) =>
    set({
      currentExport: data,
    }),

  currentImport: "",
  setCurrentImport: (data) =>
    set({
      currentImport: data,
    }),

  currentRole: "",
  setCurrentRole: (data) =>
    set({
      currentRole: data,
    }),

  breadCrumb: [],
  setBreadCrumb: (data) =>
    set({
      breadCrumb: data,
    }),

  sidebarMinMax: false,
  setSidebarMinMax: (data) =>
    set({
      sidebarMinMax: data,
    }),

  setting: null,
  setSetting: (data) =>
    set({
      setting: data,
    }),

  // BTS0511: scorecard click filter — scorecards write, DashboardTable reads
  scorecardFilter: null,
  setScorecardFilter: (data) =>
    set({
      scorecardFilter: data,
    }),

  // FLM dashboard: show/hide site_maintenance across scorecards, charts and table
  showSiteMaintenance: false,
  setShowSiteMaintenance: (data) =>
    set({
      showSiteMaintenance: data,
    }),
}));
